export const SET_PRIVATE_INFO = 'SET_PRIVATE_INFO';
export const STASH_PRIVATE_INFO_CHANGES = 'STASH_PRIVATE_INFO_CHANGES';
export const SET_SAVING_PRIVATE_INFO_STATUS = 'SET_SAVING_PRIVATE_INFO_STATUS';
export const CLEAR_PRIVATE_INFO = 'CLEAR_PRIVATE_INFO';
export const SET_LOADING = 'SET_LOADING';
